<template>
    <AxRoadPage :title="$t('axRoadSearchResults')" class="radial-search">
        <div v-if="isRadialSearchLoading" class="l-center">
            <VSpinner
                :size="24"
                :speed="1"
                line-fg-color="black"
                line-bg-color="transparent"
            />
        </div>
        <div v-else class="radial-search__results">
            <div
                v-for="[date, results] in dateGroupedResults"
                :key="date"
                class="radial-search__date-group"
            >
                <h3 class="radial-search__date-header">
                    {{ localeFormatDate(date) }}
                </h3>
                <AxRoadRadialSearchListItem
                    v-for="(result, idx) in results"
                    :key="result.asset_id + '-' + date + '-' + idx"
                    :result="result"
                    :to="{
                        name: 'axRoadSearchResultDetails',
                        params: { id: trackerId(result.asset_id) },
                        query: { date },
                    }"
                />
            </div>
        </div>
    </AxRoadPage>
</template>

<script>
import AxRoadPage from '@/components/ax-road/AxRoadPage'
import AxRoadRadialSearchListItem from '@/components/ax-road/AxRoadRadialSearchListItem'
import VSpinner from 'vue-simple-spinner'
import { mapActions, mapGetters, mapState } from 'vuex'
import moment from 'moment'
import { groupBy } from 'lodash'

export default {
    name: 'RadialSearchResultsView',
    components: {
        AxRoadPage,
        AxRoadRadialSearchListItem,
        VSpinner,
    },
    computed: {
        ...mapState('axroad', ['isRadialSearchLoading', 'radialSearchResults']),
        ...mapGetters('tracker', ['assetsByAssetId']),
        ...mapState('axroad', ['radialSearchStart']),
        dateGroupedResults() {
            return Object.entries(
                groupBy(this.radialSearchResults, ({ start }) =>
                    this.formatDate(start)
                )
            ).reverse()
        },
    },
    methods: {
        ...mapActions('axroad', ['fetchRadialSearchResults']),
        formatDate(date) {
            return moment(date).format('YYYY-MM-DD')
        },
        localeFormatDate(date) {
            return moment(date).format('LL')
        },
        trackerId(assetId) {
            return this.assetsByAssetId[assetId]?.id
        },
    },
}
</script>

<i18n>
{
    "en": {
        "axRoadSearchResults": "Search Results"
    },
    "de": {
        "axRoadSearchResults": "Suchergebnisse"
    },
    "fr": {
        "axRoadSearchResults": "Résultats de la recherche"
    },
    "it": {
        "axRoadSearchResults": "Risultati della ricerca"
    }
}
</i18n>

<style lang="scss" scoped>
.radial-search {
    &__date-group {
        margin-bottom: 12px;
    }
    &__date-header {
        margin: 12px 0;
    }
}
</style>
